import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import FundHouseSectorMappingManual from "./FundHouseSectorMappingManual";

export default function FundHouseSectorMapping() {
  const { loading } = useAuth() as any;

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return <FundHouseSectorMappingManual />;
}
